import Api from './api';

const DiariasService = {

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/diaria/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/diaria/buscar?${params}`)
        return response
    }
}

export default DiariasService;